import { BaseApi } from "../base.js";
import { API } from "../constants.js";
import dayjs from "dayjs";
import { WALLET_HISTORY_TYPE_IDS } from "@/views/History/constants/constants.js";

export class TransactionsApi extends BaseApi {
  // query — форма экрана фильтров (stores/historyFilters.js); offset > 0 дописывает операции в стор
  getHistory(query = {}, { limit, offset = 0 }, options = {}) {
    const filters = {
      transaction_types_ids: WALLET_HISTORY_TYPE_IDS,
      account_type_ids: [1, 7],
      coins_ids: null,
      coinhold_id: null,
      type: "wallet",
    };

    if (query.type) {
      filters.type = query.type;
    }
    if (query.transactionType) {
      filters.transaction_types_ids = Array.isArray(query.transactionType)
        ? query.transactionType.map(Number)
        : [Number(query.transactionType)];
    }
    if (query.coin) {
      filters.coins_ids = [Number(query.coin)];
    }
    if (query.date?.[1]) {
      filters.from = dayjs(query.date[0]).format("YYYY-MM-DD");
      filters.to = dayjs(query.date[1]).format("YYYY-MM-DD");
    }

    return this.request(
      () =>
        this.r.post(
          `${API.ENDPOINT}/history/users`,
          { ...filters, limit, offset },
          {},
          options,
        ),
      (d) => this.user.setTransactions(d, { append: offset > 0 }),
    );
  }
}
